const header = document.querySelector('[data-cs-header]');

if (header) {
  const menuToggle = header.querySelector('[data-cs-menu-toggle]');
  const megaMenu = header.querySelector('[data-cs-mega-menu]');
  const cartToggle = header.querySelector('[data-cs-cart-toggle]');
  const cartClose = header.querySelector('[data-cs-cart-close]');
  const cartDrawer = header.querySelector('[data-cs-cart-drawer]');
  const overlay = header.querySelector('[data-cs-overlay]');
  const cartItemsEl = header.querySelector('[data-cs-cart-items]');
  const cartCountEls = header.querySelectorAll('[data-cs-cart-count]');
  const subtotalEl = header.querySelector('[data-cs-cart-subtotal]');
  const shippingTextEl = header.querySelector('[data-cs-shipping-text]');
  const shippingFillEl = header.querySelector('[data-cs-shipping-fill]');
  const thresholdCents = parseInt(cartDrawer?.dataset.thresholdCents || '0', 10);
  let currentCurrency = cartDrawer?.dataset.currency || 'USD';

  const PANEL_TRANSITION_MS = 350;

  function openPanel(panel, toggleBtn) {
    if (!panel) return;
    panel.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      panel.classList.add('is-open');
      overlay.classList.add('is-visible');
    });
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
  }

  function closePanel(panel, toggleBtn) {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');

    const otherOpen =
      (panel !== megaMenu && megaMenu.classList.contains('is-open')) ||
      (panel !== cartDrawer && cartDrawer.classList.contains('is-open'));

    if (!otherOpen) overlay.classList.remove('is-visible');

    setTimeout(() => {
      if (!panel.classList.contains('is-open')) panel.hidden = true;
      if (!megaMenu.classList.contains('is-open') && !cartDrawer.classList.contains('is-open')) {
        overlay.hidden = true;
      }
    }, PANEL_TRANSITION_MS);
  }

  menuToggle?.addEventListener('click', () => {
    if (megaMenu.classList.contains('is-open')) {
      closePanel(megaMenu, menuToggle);
    } else {
      if (cartDrawer.classList.contains('is-open')) closePanel(cartDrawer, cartToggle);
      openPanel(megaMenu, menuToggle);
    }
  });

  cartToggle?.addEventListener('click', () => {
    if (cartDrawer.classList.contains('is-open')) {
      closePanel(cartDrawer, cartToggle);
    } else {
      if (megaMenu.classList.contains('is-open')) closePanel(megaMenu, menuToggle);
      openPanel(cartDrawer, cartToggle);
    }
  });

  cartClose?.addEventListener('click', () => closePanel(cartDrawer, cartToggle));

  overlay?.addEventListener('click', () => {
    if (megaMenu.classList.contains('is-open')) closePanel(megaMenu, menuToggle);
    if (cartDrawer.classList.contains('is-open')) closePanel(cartDrawer, cartToggle);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (megaMenu.classList.contains('is-open')) closePanel(megaMenu, menuToggle);
    if (cartDrawer.classList.contains('is-open')) closePanel(cartDrawer, cartToggle);
  });

  function formatMoney(cents, currency) {
    const value = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || currentCurrency,
      }).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  }

  function resizeImage(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, `_${size}x$1$2`);
  }

  function buildItemRow(item) {
    const image = item.image
      ? `<img src="${resizeImage(item.image, 200)}" alt="${item.product_title}" class="cs-cart-item__image" loading="lazy" width="100" height="100">`
      : '';
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cs-cart-item__variant">${item.variant_title}</p>`
        : '';

    return `
      <div class="cs-cart-item" data-cs-cart-item data-key="${item.key}">
        <div class="cs-cart-item__media">${image}</div>
        <div class="cs-cart-item__info">
          <a href="${item.url}" class="cs-cart-item__title">${item.product_title}</a>
          ${variant}
          <div class="cs-cart-item__qty">
            <button type="button" data-cs-qty-decrease aria-label="Decrease quantity">−</button>
            <span data-cs-qty-value>${item.quantity}</span>
            <button type="button" data-cs-qty-increase aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="cs-cart-item__price-col">
          <p class="cs-cart-item__price" data-cs-line-price>${formatMoney(item.final_line_price, item.currency)}</p>
          <button type="button" class="cs-cart-item__remove" data-cs-remove>Remove</button>
        </div>
      </div>`;
  }

  function renderCart(cart) {
    currentCurrency = cart.currency || currentCurrency;

    cartCountEls.forEach((el) => {
      el.textContent = cart.item_count;
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);

    if (shippingTextEl && shippingFillEl) {
      const remaining = thresholdCents - cart.total_price;
      if (thresholdCents <= 0 || remaining <= 0) {
        shippingTextEl.textContent = "You've unlocked free shipping";
        shippingFillEl.style.width = '100%';
      } else {
        shippingTextEl.textContent = `You're ${formatMoney(remaining, cart.currency)} away from free shipping`;
        shippingFillEl.style.width = `${Math.min(100, (cart.total_price / thresholdCents) * 100)}%`;
      }
    }

    if (cartItemsEl) {
      cartItemsEl.innerHTML =
        cart.item_count === 0
          ? '<p class="cs-cart-drawer__empty">Your bag is empty.</p>'
          : cart.items.map(buildItemRow).join('');
    }
  }

  async function changeItem(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await response.json();
    renderCart(cart);
  }

  cartItemsEl?.addEventListener('click', (event) => {
    const row = event.target.closest('[data-cs-cart-item]');
    if (!row) return;

    const key = row.dataset.key;
    const qtyEl = row.querySelector('[data-cs-qty-value]');
    const currentQty = parseInt(qtyEl?.textContent || '0', 10);

    if (event.target.closest('[data-cs-qty-increase]')) {
      changeItem(key, currentQty + 1);
    } else if (event.target.closest('[data-cs-qty-decrease]')) {
      changeItem(key, Math.max(0, currentQty - 1));
    } else if (event.target.closest('[data-cs-remove]')) {
      changeItem(key, 0);
    }
  });

  async function refreshCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  document.addEventListener('cart:update', async (event) => {
    if (event.detail?.data?.didError) return;

    try {
      await refreshCart();
    } catch (error) {
      console.error(error);
      return;
    }

    if (cartDrawer && !cartDrawer.classList.contains('is-open')) {
      if (megaMenu?.classList.contains('is-open')) closePanel(megaMenu, menuToggle);
      openPanel(cartDrawer, cartToggle);
    }
  });

  const upsellButton = header.querySelector('[data-cs-upsell-add]');
  upsellButton?.addEventListener('click', async () => {
    const variantId = upsellButton.dataset.variantId;
    if (!variantId) return;

    upsellButton.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      renderCart(cart);
      openPanel(cartDrawer, cartToggle);
    } finally {
      upsellButton.disabled = false;
    }
  });
}
